export const ImageSize = {
  Small: 400,
  Large: 700,
};

export default {
  ImageSize,
};
